export default __webpack_public_path__ + "static/media/alloy.106f4b5d.png";